import { trigger, state, style, transition, animate } from '@angular/animations';

export const summaryAnimation = trigger('summaryAnimation', [
    state(
        'expand',
        style({
            padding: '24px 0 0 0',
            'border-top-style': 'solid',
            'max-height': '1000px',
        })
    ),
    state(
        'collapse',
        style({
            padding: '0',
            'max-height': '0px',
            'border-top-style': 'unset',
        })
    ),
    transition('* => expand', [animate('0.5s cubic-bezier(.84,.14,.65,.96)')]),
    transition('expand => collapse', [animate('0.5s cubic-bezier(.84,.14,.65,.96)')]),
]);
